<template>
  <div class="tinymceVue-Box">
    <div class="tinymceVue" :style="{'min-height': '200px'}" >
      <editor
        :id="tinymceID"
        :init="initOptions"
        :disabled="disabled"
      />
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line
import Editor from '@tinymce/tinymce-vue'
import './tinymce-imports'

export default {
  name: 'TinymceVue2',
  components: {
    Editor,
  },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tinymceID: `tinymce-${new Date().getTime()}${Math.floor(Math.random() * 10)}${Math.floor(Math.random() * 10)}`,
    }
  },
  computed: {
    initOptions() {
      return {
        language: 'zh_CN',
        ...this.options,
        selector: undefined,
        target: undefined,
      }
    },
  },
}
</script>
<style scoped>

 .loading{
    position: relative;
 }
 .tinymce_loading{
     position:absolute;
     top: 0;
     left: 0;
     background: rgba(0,0,0,0.6);
     z-index: 99999;
     opacity: 0;
     pointer-events: none;
     /* transition: all 0.3s; */
     width: 100%;
     height: 100%;
 }
 .loading .tinymce_loading{
     opacity: 1;
 }
</style>
